import { Body, Head, Html, Img, Link, Text } from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { Helpers, Routes } from "utils";
import { IPotluck } from "interfaces";

// components
import { Footer, Schedule } from "./components";

export type Props = {
  url: string;
  name: string;
  potluck: IPotluck;
};

export const Results = ({
  url,
  name,
  potluck: { party_name, date, start_time, end_time },
}: Props) => {
  return (
    <Html lang="en">
      <Head />
      <Body style={Styles.body}>
        <Img style={Styles.img} src={Helpers.getImage("email_results.png")} />
        <div style={Styles.content}>
          {/* header */}
          <Text style={Styles.textBold}>Hello {name},</Text>

          {/* paragraph */}
          <Text style={Styles.textBold}>
            Everyone has voted for their favourite dishes. The final menu of
            your potluck party,{" "}
            <Text style={{ ...Styles.text, display: "inline" }}>
              {party_name}
            </Text>
            , is ready!
          </Text>

          {/* schedule */}
          <Schedule date={date} startTime={start_time} endTime={end_time} />

          {/* button */}
          <Link href={url} style={Styles.button}>
            View Voting Results
          </Link>

          {/* footnote */}
          <Text style={Styles.footnote.note}>
            <Link
              href={Helpers.generateInterpolatedUrl(Routes.auth)}
              style={Styles.link}
            >
              Join Potluck'IN
            </Link>{" "}
            for free today—create, vote, and feast your way to the ultimate
            potluck experience!
          </Text>
        </div>
        <Footer />
      </Body>
    </Html>
  );
};
